  <div class="rsvp-dialog event-dialog-content">
    <div class='dialog-title-custom'>
      <div class='title'>
        {{ title }}
      </div>
      <div class="close-button-custom">
        <i class="far fa-times icon-regular" (click)="close()"></i>
      </div>
    </div>
    @if(description){
      <div class="dialog-body" [innerHtml]='description | safeHtml'>
      </div>
    }
</div>

